// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MBSdb","rootNoMargin":"styles_rootNoMargin__36Lvi"};